/**
 * Yapay Zeka sidebar — mevcut entity modüllerinden bağımsız.
 */
export const AI_SIDEBAR = {
    key: "Yapay Zeka",
    items: [
        {
            path: "/ai/merkez",
            title: "Akıl Merkez",
            icon: "Brain",
            description: "Tüm AI modülleri — DK v2, OCR, tahkim, öğrenme",
        },
        {
            path: "/ai/sohbet",
            title: "Akıl Sohbet",
            icon: "Bot",
            description: "Doğal dilde sorgu ve işlem",
        },
        {
            path: "/ai/resimden-muvekkil",
            title: "Resimden Müvekkil",
            icon: "ScanFace",
            description: "OCR + AI ile müvekkil kaydı",
        },
        {
            path: "/ai/resimden-dosya",
            title: "Resimden Dosya",
            icon: "FileScan",
            description: "OCR + AI ile sigorta dosyası",
        },
        {
            path: "/ai/basvuru-metni",
            title: "Başvuru Metni",
            icon: "Mail",
            description: "Sigorta mail taslağı",
        },
        {
            path: "/ai/mesaj-taslagi",
            title: "Mesaj Taslağı",
            icon: "MessageSquare",
            description: "WhatsApp / e-posta cevabı",
        },
        {
            path: "/ai/gunluk-brifing",
            title: "Günlük Brifing",
            icon: "Sunrise",
            description: "Günün operasyon özeti",
        },
        {
            path: "/ai/islem-loglari",
            title: "İşlem Logları",
            icon: "ScrollText",
            description: "AI audit kayıtları",
        },
    ],
};

export default AI_SIDEBAR;
